// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__1lXli","head":"ProcedureTableInfo_head__ykoGe"};